import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { currencySchema } from '../types';

export type AddCurrencyMutationParams = {
	code: string;
};

export const createAddCurrencyMutation = () =>
	createAuthMutation({
		params: declareParams<AddCurrencyMutationParams>(),
		request: {
			method: 'POST',
			url: '/currency',
			body: (data) => data,
		},
		response: {
			contract: zodContract(currencySchema),
		},
	});
